import { Link, Outlet } from "react-router";
import { useTranslation } from "react-i18next";
import { TodoPopover } from "../molecules/TodoPopover";
import UserNav from "../molecules/UserNav";
import LogoSmall from "../icons/LogoSmall";
import { MainNav } from "~/molecules/MainNav";
import GhostIcon from "~/icons/GhostIcon";
import { useFeatureFlagEnabled } from "posthog-js/react";
import { featureFlags } from "~/config/featureFlags";
import {
  Tooltip,
  TooltipProvider,
  TooltipContent,
  TooltipTrigger,
} from "~/atoms/tooltip";
import { AdventCandlestick } from "~/molecules/AdventCandlestick";
import { TopNavSearch } from "~/molecules/TopNavSearch";
import { ValentineGift } from "~/molecules/ValentineGift";
import { EasterEgg } from "~/molecules/EasterEgg";

const TopNav = () => {
  const { t } = useTranslation();
  const isHalloweenThemeEnabled = useFeatureFlagEnabled(
    featureFlags.halloweenTheme,
  );

  return (
    <>
      <div className="flex bg-white shadow-md">
        <div className="container flex h-16 items-center gap-2">
          <Link to="/">
            <LogoSmall height={32} width={32} />
          </Link>
          <MainNav />
          <div className="flex flex-1 justify-center">
            <TopNavSearch />
          </div>
          <div className="flex items-center gap-4">
            {isHalloweenThemeEnabled && (
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="cursor-help">
                    <GhostIcon className="animate-ghostlyFloat h-10 w-10" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{t("commons.seasonal.halloween")}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )}
            <ValentineGift />
            <EasterEgg />
            <AdventCandlestick />
            <TodoPopover />
            <UserNav />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
};

export default TopNav;
